module.exports = __webpack_public_path__ + "static/img/login.1f91748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/login.png
// module id = 1YoJ
// module chunks = 1 3